import * as types from './types'
import VeeValidateFa from 'vee-validate/dist/locale/fa'

export default {
  [types.SET_LOCALE]: (state, {value, validator, i18n, cookies}) => {
    state.$locale = value

    if (value == 'fa') {
      if (validator) validator.localize('fa', VeeValidateFa)
    } else {
      if (validator) validator.localize(value)
    }
    i18n.locale = value
    setCookie({name: types.LOCALE_COOKIE, value, cookies, maxAge: 60 * 60 * 24 * 365})
  },

  [types.SET_ACCOUNT]: (state, {value, cookies}) => {
    state.$account = value
    setCookie({name: types.ACCOUNT_COOKIE, value, cookies, maxAge: value.refreshTtl * 60})
  },

  [types.SET_REFRESHED_TOKEN]: (state, {value, cookies}) => {
    state.$account.token = value.token
    state.$account.ttl = value.ttl
    setCookie({name: types.ACCOUNT_COOKIE, value: state.$account, cookies, maxAge: state.$account.refreshTtl * 60})
  },

  [types.UNSET_ACCOUNT]: (state, cookies) => {
    state.$account = null
    if (cookies)
      setCookie({name: types.ACCOUNT_COOKIE, cookies})
  },

  [types.SET_UPLOAD_PROGRESS]: (state, value) => {
    state.$uploadProgress = value
  },

  [types.SET_DOWNLOAD_PROGRESS]: (state, value) => {
    state.$downloadProgress = value
  },

  [types.SET_OFFLINE]: (state, value) => {
    state.$offline = value
  },

  [types.SET_BREADCRUMB]: (state, value) => {
    state.$breadcrumb = value
  },

  [types.SET_SETTINGS]: (state, value) => {
    Object.keys(value).forEach(key => {
      if (value[key] === null) {
        delete value[key]
      }
    })
    state.$settings = Object.assign(state.$settings, value)
  },

  [types.SET_USER_STATUS]: (state, value) => {
    state.$userStatus = value
  },

  [types.SET_ALLOW_NAVIGATION]: (state, value) => {
    if (value) {
      document.body.classList.remove('sidebar-hidden')
      document.body.classList.add('sidebar-fixed')
    } else {
      document.body.classList.add('sidebar-hidden')
      document.body.classList.remove('sidebar-fixed')
    }
    state.$allowNavigation = value
  }
}

function setCookie({name, value, cookies, maxAge}) {
  if (value) {
    cookies.set(name, value, maxAge ? maxAge : null, null, window.location.hostname, null, 'Lax')
  } else {
    cookies.remove(name)
  }
}
